module.exports = __webpack_public_path__ + "img/577-42dfb3.png";